import { render } from "./WordsOfLight.vue?vue&type=template&id=2009ca54"
import script from "./WordsOfLight.vue?vue&type=script&lang=js"
export * from "./WordsOfLight.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__